import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M746.667 106.667V1493.33H1173.33V106.667H746.667zM1056 224H864V1376H1056V224zM106.667 533.333H533.333V1493.33H106.667V533.333zM224 650.667H416V1376H224V650.667z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1920 1706.67H0V1824H1920V1706.67Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1386.67 746.667H1813.33V1493.33H1386.67V746.667ZM1504 864H1696V1376H1504V864Z",
  fillRule: "evenodd"
}));

var IconAnalyticsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAnalyticsLine, _Component);

  var _super = _createSuper(IconAnalyticsLine);

  function IconAnalyticsLine() {
    _classCallCheck(this, IconAnalyticsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAnalyticsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAnalytics",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAnalyticsLine.displayName = "IconAnalyticsLine";
  return IconAnalyticsLine;
}(Component);

IconAnalyticsLine.glyphName = 'analytics';
IconAnalyticsLine.variant = 'Line';
IconAnalyticsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAnalyticsLine;
export { IconAnalyticsLine };